import { makeActionCreator } from '../../../../utilities'
import { AssessmentConstants } from './assessment.constant'

export const setDate = makeActionCreator(AssessmentConstants.SET_DATE, 'date')
export const setTime = makeActionCreator(AssessmentConstants.SET_TIME, 'time')
export const setDateTime = makeActionCreator(AssessmentConstants.SET_DATE_TIME, 'time', 'date')
export const setPTA = makeActionCreator(AssessmentConstants.SET_PTA, 'pta')
export const setAssessedBy = makeActionCreator(AssessmentConstants.SET_ASSESSED_BY, 'assessedBy')
export const setRolePerforming = makeActionCreator(AssessmentConstants.SET_ROLE_PERFORMING, 'rolePerforming')
export const setRolePerformingPNNV = makeActionCreator(
  AssessmentConstants.SET_ROLE_PERFORMING_PNNV,
  'rolePerformingPNNV'
)
export const setProcedurePerformedByAnotherUnit = makeActionCreator(
  AssessmentConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
  'procedurePerformedByAnotherUnit'
)
export const setProcedurePerformedByAnotherUnitPNNV = makeActionCreator(
  AssessmentConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
  'procedurePerformedByAnotherUnitPNNV'
)
export const setAction = makeActionCreator(AssessmentConstants.SET_ACTION, 'action')
export const setGaze = makeActionCreator(AssessmentConstants.SET_GAZE, 'gaze')
export const setFacialSymmetry = makeActionCreator(AssessmentConstants.SET_FACIAL_SYMMETRY, 'facialSymmetry')
export const setSpeech = makeActionCreator(AssessmentConstants.SET_SPEECH, 'speech')
export const setLimbMotorStrength = makeActionCreator(AssessmentConstants.SET_LIMB_MOTOR_STRENGTH, 'limbMotorStrength')
export const setLimbSensation = makeActionCreator(AssessmentConstants.SET_LIMB_SENSATION, 'limbSensation')
export const setSuspectedInfection = makeActionCreator(
  AssessmentConstants.SET_SUSPECTED_INFECTION,
  'suspectedInfection'
)
export const setSepsisIndicators = makeActionCreator(AssessmentConstants.SET_SEPSIS_INDICATORS, 'sepsisIndicators')
export const setPossibleSourceOfInfection = makeActionCreator(
  AssessmentConstants.SET_POSSIBLE_SOURCE_OF_INFECTION,
  'possibleSourceOfInfection'
)
export const setCustomAssessmentsFieldsAction = makeActionCreator(
  AssessmentConstants.SET_CUSTOM_ASSESSMENTS_FIELDS_ACTION
)
export const setCustomAssessmentsFields = makeActionCreator(
  AssessmentConstants.SET_CUSTOM_ASSESSMENTS_FIELDS,
  'customAssessmentsFields'
)
export const setCustomFieldOption = makeActionCreator(
  AssessmentConstants.SET_CUSTOM_FIELD_OPTION,
  '_customFieldOption',
  'fieldId',
  'fieldType',
  'responseType'
)
export const setAddToTimeLine = makeActionCreator(AssessmentConstants.SET_ADD_TO_TIMELINE, 'addToTimeline')
export const setUpdateInputRows = makeActionCreator(AssessmentConstants.SET_UPDATE_INPUT_ROWS, 'updateInputRows')
export const setState = makeActionCreator(AssessmentConstants.SET_STATE, 'assessment')
export const setHideNeuroFields = makeActionCreator(AssessmentConstants.SET_HIDE_NEURO_FIELDS, '_hideNeuroFields')
export const setHideSepsisFields = makeActionCreator(AssessmentConstants.SET_HIDE_SEPSIS_FIELDS, '_hideSepsisFields')
export const clearFields = makeActionCreator(AssessmentConstants.CLEAR_FIELDS)
export const saveAssessment = makeActionCreator(AssessmentConstants.SAVE_ASSESSMENT)
export const onSelectAssessmentProcedure = makeActionCreator(AssessmentConstants.ON_SELECT_ASSESSMENT)
export const resetState = makeActionCreator(AssessmentConstants.RESET_STATE)
